import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    getDetails(id, encoded) {
        return Axios.get(`${baseURL}patient/${id}`, {
            params: { encoded }
        }).then(response => response.data.response);
    },
    getDirectUrlDetails(encodedBusinessId, index) {
        return Axios.get(
            `${baseURL}patient/view/${encodedBusinessId}/${index}`,
            {
                params: { index: 1 }
            }
        ).then(response => response.data.response);
    },
    getPatientsByClient(params) {
        return Axios.get(`${baseURLci}ajax/patient/filter_patients_by_client`, {
            params
        }).then(response => response.data);
    },
    getPatientLetterDetails(params) {
        return Axios.get(`${baseURL}patient/letter`, {
            params
        }).then(response => response.data.response);
    },
    getPatientLetterContent(params) {
        return Axios.get(`${baseURL}patient/letter-content`, {
            params
        }).then(response => response.data.response);
    },
    getAppointments(patientId, params) {
        return Axios.get(`${baseURL}patient/${patientId}/appointments`, {
            params
        }).then(response => response.data.response);
    },
    getReminderSummary(patientId) {
        return Axios.get(
            `${baseURL}patient/reminder-summary/${patientId}`
        ).then(response => response.data.response);
    },
    printWellnessPlanSummary(wellnessPlanId) {
        return Axios.get(
            `${baseURL}patient/wellness-plan/print-summary/${wellnessPlanId}`
        ).then(response => response.data.response);
    },
    printWellnessPlanDetails(wellnessPlanId) {
        return Axios.get(
            `${baseURL}patient/wellness-plan/print-details/${wellnessPlanId}`
        ).then(response => response.data.response);
    },
    getWellnessPlanList(patientId, params) {
        return Axios.get(`${baseURL}patient/${patientId}/wellness-plan`, {
            params
        }).then(response => response.data.response);
    },
    deletePatient(patientId, params) {
        return Axios.post(`${baseURL}patient/${patientId}`, params).then(
            response => response.data.response
        );
    },
    updatePatientPhoto(params) {
        return Axios.post(`${baseURLci}patient/patient/save_photo`, params, {
            headers: { "Content-Type": params.type }
        }).then(response => response.data);
    },
    rotatePhoto(params) {
        return Axios.post(`${baseURLci}ajax/patient/rotate_photo`, params, {
            headers: { "Content-Type": params.type }
        }).then(response => response.data);
    },
    getLatestVital(patientId) {
        return Axios.get(`${baseURL}patient/latest-vitals/${patientId}`).then(
            response => response.data.response
        );
    },
    getPatientVetsource(patientId) {
        return Axios.get(`${baseURL}patient/fetch/vetsource/${patientId}`).then(
            response => response.data.response
        );
    },
    exportAllPatients(params) {
        return Axios.post(
            `${baseURL}patient/export-multiple-patient-files`,
            params
        ).then(response => response.data.response);
    },
    async getPatientRecordSharingClinics(patientId) {
        return Axios.get(
            `${baseURL}/patient/${patientId}/record-sharing-clinics`
        ).then(response => response.data.response);
    },
    async getPatientBreeds(params) {
        return Axios.get(`${baseURL}patient/breed-search`, { params }).then(
            response => response?.data?.response || null
        );
    },
    async getPatientSexes(speciesId, params) {
        return Axios.get(`${baseURL}patient/sex/${speciesId}`, params).then(
            response => response?.data?.response || null
        );
    },
    async getPatientSpecies() {
        return Axios.get(`${baseURL}reference/patient-species`).then(
            response => response?.data || null
        );
    }
};
